module.exports = __webpack_public_path__ + "static/media/jhu.aa46b658.png";